import enhancePieChart from '@/utils/functions/enhancePieChart'

export const seriesEnhanced = (state) =>
  state.series && enhancePieChart(state.series)
